<div class="logout-modal-wrapper">
  <!-- Glowing Icon Header -->
  <div class="dialog-header">
    <div class="icon-pulse-wrapper">
      <div class="pulse-ring"></div>
      <div class="icon-core">
        <mat-icon class="logout-icon">power_settings_new</mat-icon>
      </div>
    </div>
    <h2 class="dialog-title">Log Out of Admin</h2>
    <p class="dialog-subtitle">End your current administrative session</p>
  </div>

  <!-- Dialog Body Message -->
  <div class="dialog-body">
    <p class="dialog-description">
      Are you sure you want to log out? You will need to sign in again with your credentials to access the dashboard and manage athlete telemetry.
    </p>
  </div>

  <!-- Dialog Action Buttons -->
  <div class="dialog-actions">
    <button 
      type="button" 
      mat-stroked-button 
      (click)="onCancel()" 
      class="btn-cancel">
      Stay Signed In
    </button>
    <button 
      type="button" 
      mat-flat-button 
      (click)="onConfirm()" 
      class="btn-logout">
      <mat-icon>logout</mat-icon>
      <span>Log Out</span>
    </button>
  </div>
</div>
